// extracted by mini-css-extract-plugin
module.exports = {"main":"register-page_main__1QI1i","form":"register-page_form__2Nx1S","nav":"register-page_nav__11E4S","link":"register-page_link__EPC7p"};